<template>
  <Main>
    <SelectPolicy v-if="!policy" @select="updatePolicy" />
    <EndorsementSelectedPolicy v-else />
  </Main>
</template>
<script>
import SelectPolicy from "../components/SelectPolicy.vue";
import EndorsementSelectedPolicy from "../components/EndorsementSelectedPolicy.vue";
export default {
  data: () => ({
    policy: null
  }),
  components: { SelectPolicy, EndorsementSelectedPolicy },
  methods: {
    updatePolicy(item) {
      this.$router.replace({
        name: "new request endorsement",
        params: { id: item.id }
      });
      this.policy = item;
    }
  }
};
</script>
